<template>
  <t-modal
    v-if="visibleTemplateManager"
    data-testid="premade-templates-modal"
    @close="() => (visibleTemplateManager = false)"
  >
    <template #custom-modal>
      <TemplatesPicker
        @close-templates-picker="closeModal"
        @choose-template="$emit('setChoice')"
      />
    </template>
  </t-modal>
</template>

<script setup lang="ts">
  import TemplatesPicker from "@/forms/components/PremadeContainer/PremadeTemplates/TemplatesPicker/TemplatesPicker.vue";
  import { TModal } from "@topol/twig-ui";
  import { ref, onMounted, onBeforeUnmount } from "vue";

  defineEmits<{
    (e: "setChoice"): void;
  }>();

  const visibleTemplateManager = ref(false);

  function closeModal() {
    visibleTemplateManager.value = false;
  }

  function onOpenTemplatePicker() {
    visibleTemplateManager.value = true;
  }

  onMounted(() => {
    window.$event.on("openTemplatePicker", onOpenTemplatePicker);
  });

  onBeforeUnmount(() => {
    window.$event.off("openTemplatePicker", onOpenTemplatePicker);
  });
</script>
